import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSchemeDetails, getVoucherHistory, openErrorSnackbar } from "../../actions";
import authApi from "../../api/redemption";

import { useNavigate, useParams } from "react-router-dom";
import { isSchemeActive, serializeSchema } from "./scheme.utils";
import { getValue } from "../../utils/encryption";

export const useMainHook = () => {
  const dispatch = useDispatch();
  const { schemeId } = useParams();
  const navigate = useNavigate();
  const [selectedScheme, setSelectedScheme] = useState(null);
  const {
    data: { schemeData, productList },
    isLoading,
    isRedeemLoading,
  } = useSelector((state) => state.redemption);

  const getCustomerSchemeDetails = () => {
    const payload = {
      mobile_no: getValue("_userId"),
      // vehicle_no: getValue("_vehicleNumber"),
    };
    dispatch(getSchemeDetails(payload));
  };

  useEffect(() => {
    dispatch(getVoucherHistory({offerid: schemeId}))
  }, [])

  const onSuccessCb = () => {
    getCustomerSchemeDetails();
    dispatch(getVoucherHistory({offerid: schemeId}));
  }

  useEffect(() => {
    if (!!isLoading) {
      getCustomerSchemeDetails();
    } else {
      const schemeList = serializeSchema(schemeData, productList);
      setSelectedScheme(
        schemeList.find((scheme) => {
          return scheme?.offerid === Number(schemeId);
        })
      );

      const isSelectedSchemeActive = schemeList.some((scheme) => {
        return (
          Number(schemeId) === scheme.offerid &&
          isSchemeActive(scheme.redemption_end_date)
        );
      });

      if (!isSelectedSchemeActive) {
        navigate("/dashboard", { replace: true });
        dispatch(
          openErrorSnackbar({
            message: "Selected offer has Expired. Please select an active one.",
            // message: "Unauthorized access to an Expired Offer",
          })
        );
      }
    }
  }, [schemeData]);

  return {
    dispatch,
    productList,
    isLoading,
    selectedScheme,
    isRedeemLoading,
    getCustomerSchemeDetails,
    onSuccessCb
  };
};
